import { Box, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { MillInfo } from "src/store/api/generatedApi";

export const MillsLegend = ({ mills }: { mills: MillInfo[] }) => {
  const { t } = useTranslation();
  return (
    <Box>
      <Divider sx={{ my: 1 }} />
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        {t("logisticsDestinationMills")}
      </Typography>
      <Stack spacing={0.5}>
        {mills.map((mill) => (
          <Stack
            key={mill.tenant_name}
            direction="row"
            alignItems="center"
            spacing={1}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: mill.color,
              }}
            />
            <Typography variant="body2">{mill.name}</Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
